import React from "react";

const ItemDetailsFooter = ({ text }) => {
  return (
    <div className="item-details-footer-container">
      {text && (
        <div className="item-details-footer-text">
          <p>{text}</p>
        </div>
      )}
      <div
        onClick={() =>
          window.open(
            "https://apps.apple.com/us/app/iou-hub/id6744837684",
            "_blank"
          )
        }
      >
        <img
          src={require("../../../assets/images/app-store.png")}
          alt="App Store"
        />
      </div>
      <div
        onClick={() =>
          window.open(
            "https://play.google.com/store/apps/details?id=com.iouhub.app",
            "_blank"
          )
        }
      >
        <img
          src={require("../../../assets/images/google-play.png")}
          alt="Google Play"
        />
      </div>
    </div>
  );
};

export default ItemDetailsFooter;
